import { useEffect, useState } from 'react';
import { transferListSchema } from '../utils/data';
import { url } from '../utils/config';
import { useRecoilState } from 'recoil';
import myInfoAtom from '../atoms/myInfoAtom';
import Table from '../reusable_components/Table';
import fetchData from '../custom_functions/fetchData';
import { toast } from 'react-toastify';
import { title } from '../utils/style';

function TransferList() {
    const [ transferList, setTransferList ] = useState([transferListSchema, transferListSchema, transferListSchema]);
    const [ myInfo ] = useRecoilState(myInfoAtom);
    const [ filters, setFilters ] = useState({ show: 'All', type: 'All', status: 'All'});
    const [ filteredData, setFilteredData ] = useState([]);
    const [ selectedItemIndex, setSelectedItemIndex ] = useState()
    const [ reloadTable, setReloadTable ] = useState(false)

    const transferTypeOptions = ['All', 'Hub-Hub', 'Hub-Spoke', 'Spoke-Hub', 'Spoke-Spoke'];
    const showOptions = ['All', 'My Requests', 'Other Requests'];
    const statusOptions = ['All', 'Pending', 'Approved', 'Assigned', 'Returned', 'Rejected']
    console.log(window.location.origin)
    useEffect(() => { 
        const reqUrl = url + '/inventory_transfer_list';
        fetchData(reqUrl, (error) => {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }, (data) => {
            console.log(data.data)
            setTransferList(data.data)
            setFilteredData(data.data)
        });
        filterData();
    }, [reloadTable])

    useEffect(() => { filterData() }, [ filters ])


    function updateFilterData(e) {
        const { name, value } = e.target;
        const data = {...filters};
        data[name] = value;
        setFilters(data);
    }

    function filterData() {
        if ( transferList.length > 0) {
            const data = transferList.filter(transfer => 
                (filters.type !== 'All' ? transfer.type === filters.type : true) 
                && 
                (filters.show !== 'All' ? (filters.show === 'My Requests' ? transfer.to === myInfo.location_id : transfer.from === myInfo.location_id) : true)
                &&
                (filters.status !== 'All' ? transfer.status === filters.status : true) 
            );
            console.log(data)
            setFilteredData(data);
        }
    }

    const options = [
        {
            header: 'Transfer Date',
            key: 'date',
            placeHolder: 'mm-dd-yyyy'
        },
        {
            header: 'From',
            key: 'from'
        },
        {
            header: 'To',
            key: 'to'
        },
        {
            header: 'Type',
            key: 'type'
        },
        {
            header: 'Status',
            key: 'status'
        },
    ]

    return(
        <div className="p-4">
            <div className={`${title} mb-4`}>Inventory Transfer List</div>
            <div className="grid grid-cols-5">
                <div className="col-span-5 mr-2">
                    {/* <div className="border-2 border-gray-400 grid grid-cols-2 p-4">
                        <div className="pr-4 pt-2">
                            <div className="flex justify-between items-center">
                                <span  className="font-semibold text-lg py-auto ">Show</span>
                                <select name='show' value={filters.show} onChange={e => updateFilterData(e)} className="outline-none border-2 border-gray-300 rounded-full px-4 py-2 mt-2 mb-4 w-3/5">
                                    {
                                        showOptions.map((opt, ind) => <option key={ind} value={opt}>{opt}</option>)
                                    }
                                </select>
                            </div>
                            <div className="flex justify-between items-center">
                                <span  className="font-semibold text-lg ">Status</span>
                                <select name='status' value={filters.status} onChange={e => updateFilterData(e)} className="outline-none border-2 border-gray-300 rounded-full px-4 py-2 mt-2 mb-2 w-3/5">
                                    {
                                        statusOptions.map((st, ind) => <option value={st} key={ind}>{st}</option>)
                                    }
                                </select>.
                                .
                            </div>0.
                        </div>
                        <div className="pl-4 pt-2">
                            <div className="flex justify-between items-center">
                                <span  className="font-semibold text-lg ">Transfer Type</span>
                                <select name='type' value={filters.type} onChange={e => updateFilterData(e)} className="outline-none border-2 border-gray-300 rounded-full px-4 py-2 mt-2 mb-4 w-3/5">
                                    {   
                                        transferTypeOptions.map((opt, ind) => <option key={ind} value={opt}>{opt}</option>)
                                    }
                                </select>
                            </div>
                            <div className="flex justify-between items-center">
                                <input placeholder="Search"  className="outline-none border-2 border-gray-300 rounded-full px-4 py-2 mt-2 mb-2 w-4/5"/>
                                <span  className='text-white font-semibold bg-teal-400 p-2 cursor-pointer text-center rounded-md cursor-pointer '>Search</span>
                            </div>
                        </div>
                    </div> */}
                    <Table 
                        // data={ filteredData }  
                        url={url + '/inventory_transfer_list'}
                        options={ options } 
                        pagination 
                        rowClickHandler={(i) => setSelectedItemIndex(i)}
                        noButton
                        reloadTable={reloadTable}
                    />
                </div>
                {/* <div className="col-span-1 ml-2">
                    <div className='border-2 border-gray-400 h-full p-4'> 
                        <div  className="font-semibold text-lg text-center py-2 ">Transferred Items</div>
                        <div className='flex border border-gray-400 py-2 px-1 text-xs font-bold my-2 bg-yellow-500 '>
                            <span className='flex-auto'>Item Name</span>
                            <span className='flex-auto'>Quantity</span>
                        </div>
                        <div className='flex border border-gray-400 py-2 px-1 text-xs font-semibold my-2 -light'>
                            <span className='flex-auto'>{filteredData[selectedItemIndex]?.equipmentId || ''}</span>
                            <span className='flex-auto'>{filteredData[selectedItemIndex]?.quantity || ''}</span>
                        </div>
                        <div className='border border-gray-400 py-2 px-1 text-xs font-bold my-2 '>Transfer Date</div>
                        <div className="font-semibold text-center py-2 -light">{filteredData[selectedItemIndex]?.date || ''} 03:45 AM</div>
                        <div className='border border-gray-400 py-2 px-1 text-xs font-bold my-2 '>Transfer Notes</div>
                        <div className="font-semibold text-center py-2 -light">{filteredData[selectedItemIndex]?.note || ''}</div>
                        <div className='border border-gray-400 py-2 px-1 text-xs font-bold my-2 '>Transferred by</div>
                        <div className="font-semibold text-center py-2 -light ">{filteredData[selectedItemIndex]?.transferredBy || 'Transfer Pending!'}</div>
                    </div>
                </div> */}
            </div>
        </div>
    )

}
export default TransferList;